import { render, staticRenderFns } from "./SelectAccountDialog.vue?vue&type=template&id=c670f05e"
import script from "./SelectAccountDialog.vue?vue&type=script&lang=js"
export * from "./SelectAccountDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectAccountDialog.vue?vue&type=style&index=0&id=c670f05e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports